export default "__VITE_ASSET__Cz3hc8Yt__"